import React, { FC, useState } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { usePurchasesDetailModel } from "./purchasesDetailModel";
import useGlobalModel from '@/model/globalModel';
import { useDictModel } from '@/views/base/dict/dictModel';
import { supplierService } from '@/views/base/supplier/supplierService';
import { salesService } from "@/views/sales/salesService";

export const FormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal, getSalesDetail
    } = usePurchasesDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);
    
    const formVal = mode === "edit" ? editFormVal : addFormVal;
    const [saleList, setSaleList] = useState<ISelectOption[]>();
    const { user: { shopCode }, fetchSupplierList,isEditable } = useGlobalModel(({ user }) => [user]);

    //回显选中供应商带出来的数据
    const getSupplier = async (id: string) => {
        let { retData } = await supplierService.one(id);
        let data = {
            supplierCode: retData.code,
            supplierName: retData.name,
            supplierId: retData.id,
            contact: retData.contact,
            phone: retData.phone,
            saleCode: undefined,  //每次置换供应商清空已选的外贸单
        }
        updateFormVal(mode, data);
        getSaleBySupplier(data.supplierCode)
    }

    //实时根据供应商code查询外贸单列表
    const getSaleBySupplier = async (supplierCode?: string) => {
        debugger
        let data = { shopCode, code: supplierCode ?? editFormVal.supplierCode ?? "" };
        let { retData } = await salesService.pageBySupplier(data);
        setSaleList(retData?.map(item => ({
            id: item.id,
            label: item.realCode ??"",
            value: item.code ,
            })) ?? []) 
        console.log(retData);  
    }

    //报价单选中
    const saleCodeChange = (value: string, option: ISelectOption) => {
        if (option && option.value) {
            getSalesDetail(value)
        }
    }

    //客户选中
    const supplierChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getSupplier(option.id as string)
        }
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        disabled:formVal.status==='purchase.settle',
        items: [
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "供应商名称",
                fieldName: "supplierId",
                onSelectChange: supplierChange,
                placeholder: "供应商",
                rules: [{ required: true, message: "请选择供应商" }],
                selectfetchList: fetchSupplierList,
                defaultQuery: formVal.supplierName
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                placeholder: "自动带出",
                fieldName: "contact",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                placeholder: "自动带出",
                fieldName: "phone",
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "签约日期",
                fieldName: "signingTime",
            },
            // {
            //     type: FormItemTypeEnum.AsyncSelect,
            //     fieldLabel: "外贸合同",
            //     fieldName: "saleCode",
            //     onSelectChange: salesChange,
            //     rules: [{ required: true, message: "请选择外贸合同" }],
            //     selectfetchList: fetchSaleBySupplier,
            //     defaultQuery: formVal.saleCode,
            //     disable: mode === "edit"
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购合同号",
                fieldName: "purchaseCode",
                rules: [{ required: true, message: "请输入采购合同号" }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "外贸合同号",
                fieldName: "saleRealCode",
                onSelectChange: saleCodeChange,
                rules: [{ required: true, message: "请选择外贸合同" }],
                options: saleList,
                disable: mode === "edit"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "外贸合同系统单号",
                fieldName: "saleCode",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "交货日期",
                fieldName: "exWarehouseTime",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "合同总金额",
                fieldName: "amountTotal",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "签约地点",
                fieldName: "signingAddress",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: isEditable
            },
            //  {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "备注",
            //     fieldName: "note",
            // },
             {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "结算日期",
                fieldName: "settlementTime",
                // disable: false
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: isEditable
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属部门",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true
            }, {
                // type: FormItemTypeEnum.Input,
                // fieldLabel: "入库日期",
                // fieldName: "deliveryTime",
                // disable: true
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "结款日期",
                //     fieldName: "payTime",
                //     disable: true
                // }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务",
                fieldName: "reckoner",
                disable: true
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "预警付款时间",
                fieldName: "estimatedTime",
            },
            //带出
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商名称",
                fieldName: "supplierName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商Code",
                fieldName: "supplierCode",
                hidden: true
            },
        ]
    };

    const fromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: formVal,
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...fromConfig} />
    )
}